/**
 * @file いま出しているページの AI 出力を、操作ごとに重ねて出すモーダルである。
 *
 * @what: その操作の記録だけを並べ、1件を開けば答え・評価・解説もこの中で読める。
 *   下に「ほかの AI 出力も見る」を置く。
 * @why: 勉強中はリーダーから出ないという方針 (代表の判断、2026-09-09) に合わせ、その場で
 *   重ねて出す。呼び出し側がヘッダーのボタンからも⋯のメニューからも開けるよう、部品にした。
 * @failure: 描画のみ。
 */

import { Link } from "react-router-dom";
import { StudyDialog } from "../components/StudyDialog";
import { AskRecordPanel } from "./AskRecordPanel";

export function PageAskDialog({
  familyId,
  personId,
  sourceId,
  page,
  printedPage,
  noteIds = [],
  problemIds = [],
  presetId,
  label,
  onClose,
}: {
  familyId: string;
  personId: string;
  sourceId: string;
  /** 表示中のページ (リーダーの連番)。 */
  page: number;
  /** 題に出す、紙に刷られたページ番号である。 */
  printedPage: number;
  noteIds?: readonly string[];
  problemIds?: readonly string[];
  presetId: string;
  /** 操作の言い方である (AI 解説 / AI 採点)。 */
  label: string;
  onClose: () => void;
}) {
  return (
    <StudyDialog
      title={`${label}（p.${printedPage}）`}
      labelledBy="study-page-asks-title"
      onClose={onClose}
    >
      <AskRecordPanel
        familyId={familyId}
        personId={personId}
        sourceId={sourceId}
        page={page}
        noteIds={noteIds}
        problemIds={problemIds}
        presetId={presetId}
        showScope
        hideTitle
      />
      <p className="study-dialog-more">
        <Link to={`/study/${encodeURIComponent(familyId)}/asks?kind=${presetId}`}>
          ほかの AI 出力も見る
        </Link>
      </p>
    </StudyDialog>
  );
}
